<template>
  <Form
    ref="regFrom"
    :model="regFrom"
    status-icon
    :rules="formValidate"
    class="form"
  >
    <FormItem prop="phoneNumber" class="regItem">
      <div class="itemStyle">
        <Select v-model="phoneNumBefore" class="selectStyle" size="large">
          <Option
            v-for="item in numBefore"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Input
          v-model="regFrom.phoneNumber"
          placeholder="手机号"
          class="fromItem"
          size="large"
        />
      </div>
    </FormItem>
    <FormItem prop="password" class="regItem">
      <Input
        v-model="regFrom.password"
        type="password"
        placeholder="设置密码"
        class="fromItem"
        size="large"
        password
      />
    </FormItem>
    <FormItem v-if="isCheck" prop="captchaValue" class="regItem">
      <div class="itemStyle">
        <Input
          v-model="regFrom.captchaValue"
          placeholder="请输入图片校验码"
          class="fromItem checkNum"
          size="large"
        />
        <div class="captcha">
          <img @click="getCaptchaApi" :src="captcha.captchaContent" />
        </div>
      </div>
    </FormItem>
    <FormItem porp="verificationCode" class="regItem">
      <div class="itemStyle">
        <Input
          v-model="verificationCode"
          placeholder="请输入短信验证码"
          class="fromItem checkNum"
          size="large"
        />
        <div class="loadingStyle">
          <span
            v-if="!loading"
            @click="postVerificationCode"
            class="loadingStyleCode"
          >
            {{ loadingMsg }}
          </span>
          <span v-else
            ><i class="ivu-load-loop ivu-icon ivu-icon-ios-loading"></i
            >{{ count }}秒后重新获取
          </span>
        </div>
      </div>
    </FormItem>
    <FormItem class="button regItem">
      <Button
        :disabled="isDisabled"
        type="primary"
        @click="submitForm"
        class="fromItem"
        size="large"
        >注 册</Button
      >
    </FormItem>
  </Form>
</template>
<script>
export default {
  watch: {
    verificationCode(newVal) {
      if (newVal === null || newVal === "" || newVal.length < 6) {
        this.isDisabled = true;
      } else {
        this.handleSubmit("null", null);
      }
    }
  },
  data() {
    // 校验手机号码
    let patterPhone = /^1[0-9]{10}$/;
    const validatePhone = (rule, value, callback) => {
      if (!patterPhone.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        this.postValidateAccountApi(value, callback);
      }
    };
    //校验密码
    let patterPass = /^\S{6,}$/;
    const validatePass = (rule, value, callback) => {
      if (!patterPass.test(value)) {
        callback(new Error("请输入6位以上的密码"));
      } else {
        callback();
      }
    };
    return {
      isCheck: false,
      isCeckMassage: "请输入4位的图片校验码，不区分大小写",
      captcha: "",
      loading: false,
      loadingMsg: "获取短信验证码",
      isDisabled: true, //是否可以点击注册
      count: "",
      timer: null,
      phoneNumBefore: 86,
      verificationCode: null,
      regFrom: {
        phoneNumber: null,
        password: null,
        captchaId: null,
        captchaValue: null
      },
      numBefore: [{ label: "中国 +86", value: 86 }],
      formValidate: {
        phoneNumber: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        captchaValue: [{ validator: this.validateimgNum, trigger: "blur" }]
      },
      formValidateImg: {
        phoneNumber: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      },
      formValidateNoImg: {
        phoneNumber: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      },
      patterImgNum: /^[a-zA-Z0-9]{4}$/,
      validateimgNum: (rule, value, callback) => {
        if (!this.patterImgNum.test(value) || value === null || value === "") {
          callback(new Error(this.isCeckMassage));
        } else {
          callback();
        }
      },
      validateimgNum2: (rule, value, callback) => {
        if (!this.patterImgNum.test(value) || value === null || value === "") {
          callback(new Error(this.isCeckMassage));
        } else {
          const regFromBefore = {
            actionCode: 1,
            receiver: this.regFrom.phoneNumber,
            sendType: "sms",
            captchaId: this.regFrom.captchaId,
            captchaValue: this.regFrom.captchaValue
          };
          this.postVerificationCodeApi(regFromBefore, callback);
        }
      },
      visible: true
    };
  },
  computed: {
    isLogin: {
      get() {
        return this.$store.state.isLogin;
      },
      set(isLogin) {
        this.$store.dispatch("commitIsLogin", isLogin);
      }
    }
  },
  methods: {
    //获取手机短信验证码，校验是否可以直接获取
    postVerificationCode() {
      if (this.regFrom.captchaId === null) {
        const regFromBefore = {
          actionCode: 1,
          receiver: this.regFrom.phoneNumber,
          sendType: "sms"
        };
        this.handleSubmit("sms", regFromBefore);
      } else {
        const regFromBefore = {
          actionCode: 1,
          receiver: this.regFrom.phoneNumber,
          sendType: "sms",
          captchaId: this.regFrom.captchaId,
          captchaValue: this.regFrom.captchaValue
        };

        this.formValidate.captchaValue[0].validator = this.validateimgNum2;
        this.handleSubmit("sms", regFromBefore);
      }
    },
    //校验表单是否通过，提交表单
    handleSubmit(type, data) {
      this.$refs["regFrom"].validate(valid => {
        if (valid) {
          if (type === "sms") {
            if (data.captchaId === undefined) {
              if (this.$cookies.isKey(data.receiver)) {
                this.getCaptchaApi();
              } else {
                this.postVerificationCodeApi(data);
              }
            }
          } else if (type === "null") {
            this.isDisabled = false;
          } else {
            this.submitForm();
          }
        }
      });
    },
    //加载显示
    getLoading() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.loading = true;
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.clearTimer();
          }
        }, 1000);
      }
    },
    //清除定时器
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.loading = false;
    },
    //获取短信验证码
    postVerificationCodeApi(data, callback) {
      this.$axios
        .postVerificationCode(data)
        .then(res => {
          this.$Message.success(res.data.data);
          this.isCheck = false;
          this.getLoading();
          var start = new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1
          );
          this.$cookies.set(data.receiver, "true", start);
          this.regFrom.captchaId = null;
          this.regFrom.captchaValue = null;
          this.formValidate.captchaValue[0].validator = this.validateimgNum;
        })
        .catch(error => {
          switch (error.status) {
            case 400:
              switch (error.data.code) {
                case 3001:
                  this.formValidate.captchaValue[0].validator = this.validateimgNum;
                  callback(new Error(error.data.data));
                  break;
                case 3002:
                  this.getCaptchaApi();
                  this.formValidate.captchaValue[0].validator = this.validateimgNum;
                  callback(new Error(error.data.data));
                  break;
              }
              break;
          }
        });
    },
    //获取图片验证码
    getCaptchaApi() {
      this.$axios.getCaptcha().then(res => {
        this.captcha = res.data.data;
        this.isCheck = true;
        this.clearTimer();
        this.regFrom.captchaId = this.captcha.captchaId;
        this.loadingMsg = "重新获取验证码";
        this.formValidate.captchaValue[0].validator = this.validateimgNum;
      });
    },
    //提交表单信息
    submitForm() {
      const data = {
        password: this.regFrom.password,
        phoneNumber: this.regFrom.phoneNumber,
        verificationCode: this.verificationCode
      };
      this.postUserRegisterApi(data);
    },
    //提交注册表单
    postUserRegisterApi(data) {
      this.$axios.postUserRegister(data).then(() => {
        this.getUserMessageApi();
        this.clearMsg();
      });
    },
    clearMsg() {
      this.regFrom = {
        phoneNumber: null,
        password: null,
        captchaId: null,
        captchaValue: null
      };
    },
    //获取用户信息
    getUserMessageApi() {
      this.$axios.getUserMessage().then(res => {
        this.$store.dispatch("commitUserMsg", res.data.data);
        this.$store.dispatch("commitIsShow", false);
        this.$Message.success(res.data.data);
      });
    },
    //校验是否需要注册
    blurPhoneNumber() {
      this.postValidateAccountApi();
    },
    //远程校验账号是否已被注册
    postValidateAccountApi(accountName, callback) {
      const data = {
        accountName: accountName
      };
      this.$axios.postValidateAccount(data).then(res => {
        if (!res.data.data.valid) {
          callback(new Error(res.data.data.reason));
        } else {
          callback();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.regItem {
  margin-left: 3px;
  margin-right: 3px;
}
.loadingStyle {
  text-align: center;
  width: 128px;
  .loadingStyleCode:hover {
    color: #2b85e4;
    cursor: pointer;
  }
}
.selectStyle {
  width: 100px;
}
.fromItem {
  margin: 6px 0;
  width: 100%;
}
.button {
  text-align: center;
  margin-top: 20px;
}
.form {
  margin-top: 20px;
  position: relative;
}

.title {
  color: #fff;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
  height: 80px;
  line-height: 80px;
}
.forgetPassword {
  position: absolute;
  right: 0px;
  top: -22px;
  color: #c0c4cc;
}
.toResit {
  position: absolute;
  left: 0px;
  top: -22px;
  color: #9ca1aa;
}
.privacy {
  font-size: 12px;
}
.socialLogin {
  font-size: 25px;
}
.socialLoginTitle {
  font-size: 6px;
}

.socialLoginContext {
  width: 100%;
  text-align: center;
}
.context:hover {
  color: #01bc0d;
}
.checkNum {
  width: 300px;
}
.context {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  color: #9ca1aa;
}
.wechart {
  width: 40px;
}
.itemStyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
